import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

class ToggleInput extends React.PureComponent {

    static propTypes = {
        value: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([
            PropTypes.string.isRequired,
            PropTypes.object.isRequired
        ]),
        ariaLabel: PropTypes.string,
        field: PropTypes.string,
        labelClassName: PropTypes.string,
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        disableInputOnly: PropTypes.bool,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        className: PropTypes.string,
        onChangeOverride: PropTypes.func,
        index: PropTypes.number,
        testId: PropTypes.string,
    };

    static defaultProps = {
        value: '',
        label: '',
        ariaLabel: '',
        field: '',
        labelClassName: '',
        defaultChecked: true,
        onChange: _.noop,
        onClick: _.noop,
        className: '',
        disabled: false,
        disableInputOnly: false
    };

    state = {
        checked: !!this.props.checked
    };

    UNSAFE_componentWillReceiveProps (newProps) {
        if (newProps.checked !== this.props.checked) {
            this.setState({ checked: !!newProps.checked });
        }
    }

    _handleChange = () => {
        const { checked } = this.state;
        const { field, index, disabled, onChange } = this.props;

        if (disabled) {
            return;
        }

        const nextChecked = !checked;

        this.setState({ checked: nextChecked }, () => {
            /* passing field name, toggle status and index of the element if necessary
            (used for photocards, but it can be useful for other iterable element). */
            if (field) {
                onChange(field, nextChecked, index);
            } else {
                onChange(nextChecked);
            }
        });
    };

    render () {
        const {
            value,
            ariaLabel,
            label,
            labelClassName,
            className,
            disabled,
            disableInputOnly,
            onClick,
            onChangeOverride,
            testId,
        } = this.props;
        const { checked } = this.state;
        const containerClasses = classnames(className, 'clearfix', 'toggle', {
            'toggle--checked': checked,
            'toggle--disabled': disabled && !disableInputOnly
        });

        return (
            <div className={ containerClasses }>
                <input type="checkbox"
                       id={ value }
                       className={ classnames({ 'toggle--disabled': disabled && disableInputOnly }) }
                       name={ value }
                       defaultChecked={ checked }
                       onChange={ onChangeOverride || this._handleChange }
                       onClick={ onClick }
                       data-test-id={ testId } />
                <div className="toggle-inner-wrapper">
                    <div className="toggle__lane pull-left">
                        <div className="otrl otrl-rotate-90 otrl-remove" />
                        <div className="toggle__handle" />
                        <div className="otrl otrl-select" />
                    </div>

                    <label htmlFor={ value } aria-label={ ariaLabel } className={ labelClassName }>
                        { label }
                    </label>
                </div>
            </div>
        );
    }

}

export default ToggleInput;
